import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Tabs } from 'antd'
import { Page,Crud } from '../../components'
const {CrudTable} = Crud;
const { TabPane } = Tabs;
export class DefaultPage extends Component {
  static propTypes = {
    furui: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
    componentDidMount() {
    const { frui_qpgoodsPage, currentFrui_qpgoods } = this.props.furui;
    this.fetchList(frui_qpgoodsPage);
  }

  fetchList = (page, values) => {
    const { getFrui_qpgoodsList } = this.props.actions;
    let params = Object.assign({}, { page: page }, values)
    getFrui_qpgoodsList(params);
  }
    getDataSource() {
    const { furui } = this.props;
    const { frui_qpgoodsById, frui_qpgoodsList } = furui;
    if (!frui_qpgoodsList) return [];
    return frui_qpgoodsList.map(id => frui_qpgoodsById[id]);
  }
  get listProps() {
 const { furui, actions } = this.props
    const { getFrui_qpgoodsListPending, frui_qpgoodsTotal, frui_qpgoodsPage } = furui
    const { deleteFrui_qpgoods, chooseCurrentFrui_qpgoods, frui_qpgoodsModalChange } = actions;
    return {
      dataSource: this.getDataSource(),
      loading: getFrui_qpgoodsListPending,
      columns: [
        {
          title: "序号",
          dataIndex: 'id',
          key: 'id',
          width: 80,
        },
        {
          title: "批号",
          dataIndex: 'ph',
          key: 'ph',
          width: 120,
        },{
          title: "气瓶编号",
          dataIndex: 'bh',
          key: 'bh',
          width: 140,
        },{
          title: "气瓶唯一追溯编号",
          dataIndex: 'wybh',
          key: 'wybh',
          width: 120,
        },{
          title: "公秤容积",
          dataIndex: 'gcrj',
          key: 'gcrj',
          width: 120,
        },{
          title: "制造日期",
          dataIndex: 'zzrq',
          key: 'zzrq',
          width: 120,
        },{
          title: "内胆设计壁厚",
          dataIndex: 'ndsjbh',
          key: 'ndsjbh',
          width: 120,
        },{
          title: "内封头设计厚度",
          dataIndex: 'nftsjhd',
          key: 'nftsjhd',
          width: 120,
        },{
          title: "重量",
          dataIndex: 'weight',
          key: 'weight',
          width: 120,
        },{
          title: "内胆筒体设计厚度",
          dataIndex: 'ndttsjhd',
          key: 'ndttsjhd',
          width: 120,
        },{
          title: "内胆直径",
          dataIndex: 'ndzj',
          key: 'ndzj',
          width: 120,
        },{
          title: "内胆气压试验压力",
          dataIndex: 'ndqysyyl',
          key: 'ndqysyyl',
          width: 120,
        },{
          title: "电子标识",
          dataIndex: 'dzbs',
          key: 'dzbs',
          render: (text) => {
            return <div> <a href={text}>预览</a> <a>生成</a> </div>
          }
        },{
          title: "钢印截图",
          dataIndex: 'gyjt',
          key: 'gyjt',
          render: (text) => {
            return <div> <a href={text}>预览</a> </div>
          }
        },{
          title: "产品合格证",
          dataIndex: 'hgz',
          key: 'hgz',
          render: (text) => {
            return<div> <a href={text}>预览</a> <a>生成</a> </div>
          }
        },
      ],
      pagination: {
        total: frui_qpgoodsTotal,
        current: frui_qpgoodsPage,
        onChange: (page) => {
          this.fetchList(page);
        }
      },
      op: [
        {
          key: 3,
          name: '删除',
          buttonProps: {
            icon: "delete",
            type: "danger"
          },
          needConfirm: true,
          confirmTitle: "确认删除"
        }
      ],
      handleMenuClick: (record, item) => {
        if (item.key == 1) {
          chooseCurrentFrui_qpgoods(record);
          frui_qpgoodsModalChange(true, "updata");
        } else if (item.key == 3) {
          deleteFrui_qpgoods(record.id).then((data) => {
            this.fetchList(frui_qpgoodsPage);
          })
        }
      }
    }
  } 
  
   getDataSource2() {
    const { furui } = this.props;
    const { frui_qpgoodsById, frui_qpgoodsList } = furui;
    if (!frui_qpgoodsList) return [];
    return frui_qpgoodsList.map(id => frui_qpgoodsById[id]);
  }
  get listProps2() {
 const { furui, actions } = this.props
    const { getFrui_qpgoodsListPending, frui_qpgoodsTotal, frui_qpgoodsPage } = furui
    const { deleteFrui_qpgoods, chooseCurrentFrui_qpgoods, frui_qpgoodsModalChange } = actions;
    return {
      dataSource: this.getDataSource(),
      loading: getFrui_qpgoodsListPending,
      columns: [
        {
          title: "序号",
          dataIndex: 'id',
          key: 'id',
          width: 80,
        },
        {
          title: "批号",
          dataIndex: 'ph',
          key: 'ph',
          width: 120,
        },{
          title: "气瓶编号",
          dataIndex: 'bh',
          key: 'bh',
          width: 140,
        },{
          title: "气瓶唯一追溯编号",
          dataIndex: 'wybh',
          key: 'wybh',
          width: 120,
        },{
          title: "公秤容积",
          dataIndex: 'gcrj',
          key: 'gcrj',
          width: 120,
        },{
          title: "制造日期",
          dataIndex: 'zzrq',
          key: 'zzrq',
          width: 120,
        },{
          title: "内胆设计壁厚",
          dataIndex: 'ndsjbh',
          key: 'ndsjbh',
          width: 120,
        },{
          title: "内封头设计厚度",
          dataIndex: 'nftsjhd',
          key: 'nftsjhd',
          width: 120,
        },{
          title: "重量",
          dataIndex: 'weight',
          key: 'weight',
          width: 120,
        },{
          title: "内胆筒体设计厚度",
          dataIndex: 'ndttsjhd',
          key: 'ndttsjhd',
          width: 120,
        },{
          title: "内胆直径",
          dataIndex: 'ndzj',
          key: 'ndzj',
          width: 120,
        },{
          title: "内胆气压试验压力",
          dataIndex: 'ndqysyyl',
          key: 'ndqysyyl',
          width: 120,
        },{
          title: "电子标识",
          dataIndex: 'dzbs',
          key: 'dzbs',
          render: (text) => {
            return <div> <a href={text}>预览</a> <a>生成</a> </div>
          }
        },{
          title: "钢印截图",
          dataIndex: 'gyjt',
          key: 'gyjt',
          render: (text) => {
            return <div> <a href={text}>预览</a> </div>
          }
        },{
          title: "产品合格证",
          dataIndex: 'hgz',
          key: 'hgz',
          render: (text) => {
            return<div> <a href={text}>预览</a> <a>生成</a> </div>
          }
        },
      ],
      pagination: {
        total: frui_qpgoodsTotal,
        current: frui_qpgoodsPage,
        onChange: (page) => {
          this.fetchList(page);
        }
      },
      handleMenuClick: (record, item) => {
        if (item.key == 1) {
          chooseCurrentFrui_qpgoods(record);
          frui_qpgoodsModalChange(true, "updata");
        } else if (item.key == 3) {
          deleteFrui_qpgoods(record.id).then((data) => {
            this.fetchList(frui_qpgoodsPage);
          })
        }
      }
    }
  } 

   getDataSource3() {
    const { furui } = this.props;
    const { frui_qpgoodsById, frui_qpgoodsList } = furui;
    if (!frui_qpgoodsList) return [];
    return frui_qpgoodsList.map(id => frui_qpgoodsById[id]);
  }
  get listProps3() {
 const { furui, actions } = this.props
    const { getFrui_qpgoodsListPending, frui_qpgoodsTotal, frui_qpgoodsPage } = furui
    const { deleteFrui_qpgoods, chooseCurrentFrui_qpgoods, frui_qpgoodsModalChange } = actions;
    return {
      dataSource: this.getDataSource(),
      loading: getFrui_qpgoodsListPending,
      columns: [
        {
          title: "序号",
          dataIndex: 'id',
          key: 'id',
          width: 80,
        },
        {
          title: "批号",
          dataIndex: 'ph',
          key: 'ph',
          width: 120,
        },{
          title: "气瓶编号",
          dataIndex: 'bh',
          key: 'bh',
          width: 140,
        },{
          title: "气瓶唯一追溯编号",
          dataIndex: 'wybh',
          key: 'wybh',
          width: 120,
        },{
          title: "公秤容积",
          dataIndex: 'gcrj',
          key: 'gcrj',
          width: 120,
        },{
          title: "制造日期",
          dataIndex: 'zzrq',
          key: 'zzrq',
          width: 120,
        },{
          title: "内胆设计壁厚",
          dataIndex: 'ndsjbh',
          key: 'ndsjbh',
          width: 120,
        },{
          title: "内封头设计厚度",
          dataIndex: 'nftsjhd',
          key: 'nftsjhd',
          width: 120,
        },{
          title: "重量",
          dataIndex: 'weight',
          key: 'weight',
          width: 120,
        },{
          title: "内胆筒体设计厚度",
          dataIndex: 'ndttsjhd',
          key: 'ndttsjhd',
          width: 120,
        },{
          title: "内胆直径",
          dataIndex: 'ndzj',
          key: 'ndzj',
          width: 120,
        },{
          title: "内胆气压试验压力",
          dataIndex: 'ndqysyyl',
          key: 'ndqysyyl',
          width: 120,
        },{
          title: "电子标识",
          dataIndex: 'dzbs',
          key: 'dzbs',
          render: (text) => {
            return <div> <a href={text}>预览</a> <a>生成</a> </div>
          }
        },{
          title: "钢印截图",
          dataIndex: 'gyjt',
          key: 'gyjt',
          render: (text) => {
            return <div> <a href={text}>预览</a> </div>
          }
        },{
          title: "产品合格证",
          dataIndex: 'hgz',
          key: 'hgz',
          render: (text) => {
            return<div> <a href={text}>预览</a> <a>生成</a> </div>
          }
        },
      ],
      pagination: {
        total: frui_qpgoodsTotal,
        current: frui_qpgoodsPage,
        onChange: (page) => {
          this.fetchList(page);
        }
      },
      op: [
        {
          key: 3,
          name: '修改',
        },
         {
          key: 4,
          name: '删除',
        },
         {
          key: 5,
          name: '查看详情',
        }
      ],
      handleMenuClick: (record, item) => {
        if (item.key == 1) {
          chooseCurrentFrui_qpgoods(record);
          frui_qpgoodsModalChange(true, "updata");
        } else if (item.key == 3) {
          deleteFrui_qpgoods(record.id).then((data) => {
            this.fetchList(frui_qpgoodsPage);
          })
        }
      }
    }
  } 
  render() {
    return (
      <div className="home-default-page">
        {/*动态*/}
        <div style={{ marginTop: '24px' }}>
          <Tabs defaultActiveKey="1">
            <TabPane tab="车用气瓶型号" key="1">
              <Page inner>
                <CrudTable {...this.listProps} />
              </Page>
            </TabPane>
            <TabPane tab="车用氢气瓶型号" key="2">
              <Page inner>
                <CrudTable {...this.listProps2} />
              </Page>
            </TabPane>
            <TabPane tab="车用CNG钢瓶" key="3">
              <Page inner>
                <CrudTable {...this.listProps3} />
              </Page>
            </TabPane>
          </Tabs>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    furui: state.furui,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/furui/DefaultPage.js